export const config = (translations, municipalityNameList, placeList) => {
  const { place, name } = translations || {};

  return {
    fields: [
      {
        key: 1,
        name: 'place.name',
        type: 'autocomplete',
        label: 'place.name',
        optionList: placeList || [],
        getOptionLabel: (placeName) => placeName || '',
      },
      {
        key: 2,
        name: 'name',
        type: 'text',
        label: name,
      },
    ],
  };
};
